import axios from './financeiroApi';

const PATH = '/api/v1/backend/plano-contas';
export const categoriaApi = {
  // getOne: (id) => axios.get(`${PATH}/pessoa/${id}`),
  getByEmpresa: () => axios.get(`${PATH}`),
  getAll: () => axios.get(PATH),
  post: (planoContas) => axios.post(PATH, planoContas),
  put: (id, planoContas) => axios.post(`${PATH}/${id}`, planoContas),
  delete: (id) => axios.delete(`${PATH}/${id}`),
};

export const categoriaClasseApi = {
  post: (classe) => axios.post(`${PATH}/classe`, classe),
  put: (classe) => axios.put(`${PATH}/classe/${classe.id}`, classe),
  delete: (id) => axios.delete(`${PATH}/classe/${id}`),
  pesquisar: (params) => axios.get(`${PATH}/classe/pesquisar`, { params }),
};

export const categoriaVinculoApi = {
  vincular: (vinculo) => axios.put(`${PATH}/vinculo-automatico/vincular`, vinculo),
  desvincular: (vinculoId) => axios.put(`${PATH}/vinculo-automatico/desvincular/${vinculoId}`),
};
